import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Input from './ReviewText';
import Button from 'react-bootstrap/Button';
import { useForm } from 'react-hook-form';
import RateInput from './RateInput';
import RevieDescInput from './ReviewDescInput';
import { addReview } from 'redux/actions/review';

const ReviewForm = ({ inputs, data, formId }) => {
    const dispatch = useDispatch();
    const [, setFocus] = useState(false);
    const [rateValue, setRateValue] = useState({
        ratingDescription: 0,
        ratingPrice: 0,
        ratingQuality: 0,
    });

    const onSubmit = (data) => {
        const __data = {
            ...data,
            productId: formId,
        };

        dispatch(addReview(__data));
    };

    const handleBlur = () => setFocus(null);
    const handleFocus = (name) => setFocus(name);
    const handleRatingChange = (e) => {
        setRateValue({
            ...rateValue,
            [e.name]: e.value,
        });

        setValue(e.name, e.value);

        return trigger(e.name);
    };

    const { errors, handleSubmit, control, watch, trigger, setValue } = useForm({
        // mode: 'blur'
    });
    return (
        <Form onSubmit={handleSubmit(onSubmit)} inline className="form__review">
            {inputs.map((item, key) => {
                const inputProps = {
                    item,
                    errors,
                    data,
                    control,
                    watch,
                    trigger,
                    handleBlur,
                    handleFocus,
                    handleRatingChange,
                };
                return {
                    star: <RateInput key={key} {...inputProps} type="hidden" value={rateValue[item.name] || null} />,
                    textarea: <RevieDescInput key={key} {...inputProps} />,
                    text: <Input key={key} {...inputProps} />,
                }[item.type];
            })}
            <Form.Group className="text-right form__review--submit">
                <Button type="submit" className="btn__default btn__default--filled pl-4 pr-4">
                    Dodaj opinię
                </Button>
            </Form.Group>
        </Form>
    );
};

ReviewForm.propTypes = {
    inputs: PropTypes.array.isRequired,
    data: PropTypes.array,
    formId: PropTypes.string.isRequired,
};

export default ReviewForm;
